const ACCESS_TOKEN_LOCAL_STORAGE_KEY = 'accessToken';

export const getAccessTokenLocalStorage = () => localStorage.getItem(ACCESS_TOKEN_LOCAL_STORAGE_KEY);

export const setAccessTokenLocalStorage = (token: string) =>
   localStorage.setItem(ACCESS_TOKEN_LOCAL_STORAGE_KEY, token);

export const clearAccessTokenLocalStorage = () =>
   localStorage.removeItem(ACCESS_TOKEN_LOCAL_STORAGE_KEY);
